import { Box, Typography } from "@mui/material"


const Error = () => {
    return (
        <Box sx={{ marginTop: '50px', padding: '50px' }}>
            <Typography>Oops! Something went wrong.</Typography>
        </Box>
    )
}

export default Error